import { createContext, Dispatch, SetStateAction } from "react";
import { CliUser } from "../types/users";

type UserContextType = {
  user: CliUser | null | undefined;
  setUser: Dispatch<SetStateAction<CliUser | null |undefined>>
}

export const UserContext = createContext<UserContextType>({
  user: undefined,
  setUser: () => {}
})

type ButtermelonContextType = {
  bm: boolean;
  setBm: Dispatch<SetStateAction<boolean>>
}

export const ButtermelonContext = createContext<ButtermelonContextType>({
  bm: false,
  setBm: () => {}
})